import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';

import PremiumEventCard from '../Card/PremiumEventCard';
import EventCard from '../Card/EventCard';

import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports'
import { UserContext } from '../../components/UserContext'
// import { ScoreContext } from '../components/ScoreContext'
import Lottie from 'react-lottie';
import batchImg from '../../assets/images/events-banner.png';
import { default as animationData } from '../../assets/loader.json';
import {
  withAuthenticator, AmplifySignOut, ForgotPassword
} from "aws-amplify-react";
import { cx } from '@emotion/css';
import * as styles from '../events.style.js';

Amplify.configure(config)
function PremCatScreen(props) {
  const [events_category, set_events_category] = useState([]);

  const { user, setUser } = useContext(UserContext);
  const [grade_user, set_grade_user] = useState(0);
  const [premiumlevel, set_premiumlevel] = useState(0);


  const [loadedcategories, set_loadedcategories] = useState(false);

  //  const {score,setScore} = useContext(ScoreContext);

  ////console.log("Calling EventCatScreen.....")

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    ////console.log("useEffect called in EventCatScreen")

    document.title = 'Premium Categories';
    getToken();
    // console.log('Output from the API is ')
    // data =[{"id":1,"category":"SpellBowl","count":1}]
    // console.log(data)




  }, []);



  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };
    const response = await fetch(
      `https://api.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();
    // console.log(data)
    //set_userdetails(data)
    // setUser(data)
    //set_grade_user(5)

    set_grade_user(data['grade']);
    set_premiumlevel(data['premiumuser'])

    set_events_category([{ "id": 1, "category": "SpellBowl", "count": 1, "username": username, "totalquestions": 20, "time": 400, grade: data['grade'], premium: data['premiumuser'] }])
    set_loadedcategories(true)

  }


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {

        let username = ""
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {

          username = user.attributes['email']






        }
        else {

          username = user.username



        }
        getuserDetails(username, jwt)






      });




    } catch (error) {
      //console.log(error)
      Auth.signOut()
    }
  };




  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  let event_category_Cards = events_category.map(eventcategory => {
    return (
      <div key={eventcategory.id} className="col-md-4">
        <Col className="py-2 border rounded" key={eventcategory.id} >
          <PremiumEventCard imgsrc={"../../assets/" + eventcategory.category + ".png"} title="SpellBowl" time="500" key={eventcategory.id} eventcategory={eventcategory} target="premiumquiz" />




        </Col>
      </div>

    )
  })
  return (
    <div>
      {loadedcategories ?
        <div>
          <div className={cx(styles.batchBanner)}>
            <img src={batchImg} alt="" />
          </div>
          <div className={cx(styles.batchTitle)}>Public Quiz Events</div>
          <div className={cx(styles.cardEventsFluid)}>
            <Row> {event_category_Cards} </Row>
          </div>
        </div> :
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      }
    </div>
  )
}
export default PremCatScreen;
